/******************************************************************************
 * Copyright 2024 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/
// eslint-disable-next-line no-restricted-imports
export * from 'vscode-jsonrpc/lib/common/cancellation.js';
//# sourceMappingURL=cancellation.js.map